<template>
  <sheet-group class="ma-4">
    <v-sheet outlined rounded class="mb-4">
      <toolbar-view title="Список сертификатов">
        <template v-slot:barActions>
          <v-btn @click="certsLoad()" icon small class="mr-0"><v-icon small>mdi-refresh</v-icon></v-btn>
        </template>
      </toolbar-view>
      <progress-page v-if="certsStater.loading"/>
      <div v-else-if="certsStater.success">
        <alert v-if="$tools.isEmpty(certsStater.data)" icon="mdi-information-outline">Не найдено</alert>
        <v-simple-table v-else dense>
          <thead>
          <tr>
            <th v-for="(v,k) in Object.keys(certsStater.data[0].info)" :key="k">{{v}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(v,k) in certsStater.data" :key="k" @click="signAction(v.cert)">
            <td v-for="(v1,k1) in Object.keys(v.info)" :key="k1" class="text-wrap">
              {{v.info[v1]}}
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </div>
      <alert v-else-if="certsStater.error" icon="mdi-information-outline">
        <div>{{certsStater.errorMessage}}</div>
      </alert>
    </v-sheet>

    <v-text-field label="XML" v-model="xml" outlined dense hide-details class="mb-4"/>

    <progress-page v-if="certSignStater.loading"/>
    <div v-else-if="certSignStater.success">
      <v-textarea :value="certSignStater.data" label="Результат" outlined rows="10">
        <template v-slot:append>
          <v-btn small depressed @click="$tools.copyToClipboard(certSignStater.data);$store.commit('alertSuccess', 'Скопировано')">
            Скопировать
          </v-btn>
        </template>
      </v-textarea>
    </div>
    <alert v-else-if="certSignStater.error" icon="mdi-information-outline">
      <div>{{certSignStater.errorMessage}}</div>
    </alert>
  </sheet-group>

</template>

<script>
import SheetGroup from "../componentsV2/base/SheetGroup.vue";
import Stater from "../plugins/stater";
import Alert from "../componentsV2/base/Alert.vue";
import ProgressPage from "../components/ProgressPage.vue";
import ToolbarView from "../components/ToolbarView.vue";

export default {
  components: {ToolbarView, ProgressPage, Alert, SheetGroup},
  data: () => ({
    xml:'<Doctor><Name>Иванов Иван</Name></Doctor>',
    certsStater:new Stater(),
    certSignStater:new Stater(),
  }),
  mounted(){
    this.certsStater.stateLoading();
    setTimeout(()=>{
      this.certsLoad();
    }, 1000)
  },
  methods:{
    certsLoad(){
      this.certsStater.stateLoading();
      this.$cryptoPro.getCertificates().then(v=>{
        this.certsStater.data = v;
        this.certsStater.stateSuccess();
      }).catch(v=>{
        this.certsStater.stateError(v);
      })
    },
    signAction(cert){
      this.certSignStater.stateLoading()
      this.$cryptoPro.signCreate(cert, this.xml).then(v=>{
        this.certSignStater.data = v;
        this.certSignStater.stateSuccess()
      }).catch(e=>{
        this.certSignStater.stateError(e)
      })
    }
  }
}
</script>